module.exports = __webpack_public_path__ + "img/clustered.60463fa8.jpg";